import { Component, OnInit } from '@angular/core';
import { SmartModalService } from 'app/core/services/smart-modal.service';

@Component({
  selector: 'itpx-login-prompt',
  templateUrl: './login-prompt.component.html',
  styleUrls: ['./login-prompt.component.css']
})
export class LoginPromptComponent implements OnInit {

  constructor(private modalService: SmartModalService) { }

  ngOnInit() {
  }

  login() {
    this.modalService.sendResult({action: 'login'})
  }

  logout() {
    this.modalService.sendResult({action: 'logout'})
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/login-prompt/login-prompt.component.ts